import 'moment/locale/fr'
import React from 'react'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import I18n from '../../resources/i18n/I18n'
import Criteria from './Criteria'
import './autocomplete.scss'
import './filters.scss'

const GroupFilters = ({ filterList, handleChange }) => (
  <div className="d-flex w-100 flex-column align-items-center justify-content-between">
    <div className="w-100 header-criteria text-uppercase">
      <span>{I18n.t('FiltersTitle')}</span>
    </div>
    <Criteria title={I18n.t('GroupCodeCriteria')}>
      <FormControl name="code" value={filterList.code || ''} onChange={(event) => handleChange(event.target.name, event.target.value)} />
    </Criteria>
    <Criteria title={I18n.t('GroupNameCriteria')}>
      <FormControl name="name" value={filterList.name || ''} onChange={(event) => handleChange(event.target.name, event.target.value)} />
    </Criteria>
    <Criteria title={I18n.t('GroupCommentCriteria')}>
      <Form.Check
        id="enableComment"
        name="enableComment"
        checked={filterList.enableComment || undefined}
        onClick={(event) => {
          handleChange(event.target.name, event.target.checked || undefined)
        }}
        label={I18n.t('CommentCriteria')}
        type="checkbox"
      />
    </Criteria>
  </div>
)

export default GroupFilters
